module.exports = __webpack_public_path__ + "static/media/Driveway2.c5551ca6.jpg";